module.exports = __webpack_public_path__ + "static/media/lock-alt.03ebdcca.svg";